import { useTranslation } from 'react-i18next';

export default function WhyUsSection() {
  const { t } = useTranslation('common');

  const features = [
    {
      icon: 'ri-settings-3-line',
      titleKey: 'whyUs.custom.title',
      descKey: 'whyUs.custom.description',
      color: 'cyan'
    },
    {
      icon: 'ri-customer-service-line',
      titleKey: 'whyUs.support.title',
      descKey: 'whyUs.support.description',
      color: 'blue'
    },
    {
      icon: 'ri-rocket-line',
      titleKey: 'whyUs.technology.title',
      descKey: 'whyUs.technology.description',
      color: 'purple'
    },
    {
      icon: 'ri-line-chart-line',
      titleKey: 'whyUs.results.title',
      descKey: 'whyUs.results.description',
      color: 'pink'
    }
  ];

  const getColorClasses = (color: string) => {
    const colors: Record<string, { bg: string; text: string; border: string }> = {
      cyan: { bg: 'bg-cyan-50', text: 'text-cyan-600', border: 'border-cyan-200' },
      blue: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-200' },
      purple: { bg: 'bg-purple-50', text: 'text-purple-600', border: 'border-purple-200' },
      pink: { bg: 'bg-pink-50', text: 'text-pink-600', border: 'border-pink-200' }
    };
    return colors[color];
  };

  return (
    <section id="why-us" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('whyUs.title')}
          </h2>
          <p className="text-lg text-gray-600">
            {t('whyUs.subtitle')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const colors = getColorClasses(feature.color);
            return (
              <div
                key={index}
                className="group relative bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-transparent hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                {/* Icon */}
                <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${colors.bg} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feature.icon} text-2xl ${colors.text}`}></i>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {t(feature.titleKey)}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {t(feature.descKey)}
                </p>

                {/* Decorative Element */}
                <div className={`absolute top-0 right-0 w-20 h-20 ${colors.bg} rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}